import { render, staticRenderFns } from "./UnderDevelopment.vue?vue&type=template&id=27d85bcb&scoped=true"
import script from "./UnderDevelopment.vue?vue&type=script&lang=js"
export * from "./UnderDevelopment.vue?vue&type=script&lang=js"
import style0 from "./UnderDevelopment.vue?vue&type=style&index=0&id=27d85bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d85bcb",
  null
  
)

export default component.exports